(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    (() => {
    if (navigator.maxTouchPoints > 0) {
      document.documentElement.classList.add('dna-touch-device');
    }

    if (window.__dnaFilterStickyOffsetInstalled) return;
    window.__dnaFilterStickyOffsetInstalled = true;

    let stickyOffset = 0;
    let measuredViewportWidth = 0;
    const stickyStates = new WeakMap();
    const trackedToggles = new Set();

    const getToggleState = (element) => {
      let state = stickyStates.get(element);
      if (state) return state;

      const rect = element.getBoundingClientRect();
      if (rect.height <= 0) return null;

      const styles = getComputedStyle(element);
      const marginStart = parseFloat(styles.marginBlockStart) || 0;
      const marginEnd = parseFloat(styles.marginBlockEnd) || 0;
      const placeholder = document.createElement('div');
      placeholder.className = 'dna-filters-sticky-placeholder';
      placeholder.hidden = true;
      placeholder.setAttribute('aria-hidden', 'true');
      element.before(placeholder);

      state = {
        placeholder,
        height: rect.height + marginStart + marginEnd,
        /* Match the exact fixed CSS position. Previously JavaScript switched
           8px after native sticky had already engaged, leaving a brief large
           state that caused the visible delay and jump. */
        triggerY: Math.max(0, window.scrollY + rect.top - Math.max(0, stickyOffset - 8)),
      };
      stickyStates.set(element, state);
      trackedToggles.add(element);
      return state;
    };

    const updateStuckState = () => {
        document.querySelectorAll('.facets-toggle').forEach((element) => {
          const state = getToggleState(element);
          if (!state) return;

          const isStuck = window.scrollY >= state.triggerY;
          if (isStuck) {
            state.placeholder.style.height = `${state.height}px`;
            state.placeholder.hidden = false;
            element.classList.add('dna-filters-is-stuck');
          } else {
            element.classList.remove('dna-filters-is-stuck');
            state.placeholder.hidden = true;
          }
        });

        document.querySelectorAll('.facets-block-wrapper--horizontal').forEach((element) => {
            const elementRect = element.getBoundingClientRect();
            const isStuck =
              window.scrollY > 8 &&
              elementRect.top <= stickyOffset + 1 &&
              elementRect.bottom > stickyOffset;

            element.classList.toggle('dna-filters-is-stuck', isStuck);
        });
    };

    const measureStickyOffset = (force = false) => {
      const viewportWidth = document.documentElement.clientWidth;

      /* Mobile Safari fires resize events while its browser bars expand and
         collapse. Ignore those height-only changes so the sticky row does not jump. */
      if (!force && measuredViewportWidth && Math.abs(viewportWidth - measuredViewportWidth) < 2) {
        return;
      }

      trackedToggles.forEach((element) => {
        const state = stickyStates.get(element);
        element.classList.remove('dna-filters-is-stuck');
        state?.placeholder.remove();
        stickyStates.delete(element);
      });
      trackedToggles.clear();

      measuredViewportWidth = viewportWidth;

      const header = document.querySelector('header') || document.querySelector('header-component');
      const rect = header?.getBoundingClientRect();

      stickyOffset = rect && rect.height > 0
        ? Math.max(0, Math.round(rect.height))
        : 0;

      document.documentElement.style.setProperty('--dna-filter-sticky-top', `${stickyOffset}px`);
      updateStuckState();
    };

    measureStickyOffset(true);
    window.addEventListener('scroll', updateStuckState, { passive: true });
    window.addEventListener('resize', () => measureStickyOffset(false), { passive: true });
    window.addEventListener('orientationchange', () => {
      measuredViewportWidth = 0;
      window.setTimeout(() => measureStickyOffset(true), 250);
    }, { passive: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
